<template>
    <div class="styledForm">
        <div class="form">
            <div class="header">
                <h3><span v-if="!item._id">Add</span><span v-else>Update</span> a {{ name }}</h3><button v-if="item._id" @click="item = {_id: null, name: '', website: '', logo: ''}">button</button>
            </div>
            <div class="split">
                <input class="styledInput" type="text" placeholder="Name" v-model="item.name" name="styleName">
                <div class="input-group styledInput" >
                    <input type="file" placeholder="Upload file..." @change="e => onFileChange(e)"/>
                    <button class="green-btn" type="button" @click="uploadPicture"><font-awesome-icon icon="upload"></font-awesome-icon></button>
                </div>
            </div>
            <div class="split">
                <input class="styledInput" type="text" placeholder="Website" v-model="item.website" name="styleName">
                <div>
                    <button class="green-btn" v-if="!item._id" @click="createItem"><font-awesome-icon icon="plus-circle"></font-awesome-icon> Create</button>
                    <button class="green-btn" v-else @click="updateItem"><font-awesome-icon icon="edit"></font-awesome-icon> Update</button>
                </div>
            </div>
            <div v-if="item.logo != null">
                <div class="logo"><img :src="imgURL + '/brands/' + item.logo" alt="item logo"></div>
            </div>
            <div v-if="item._id != null && item._id != ''">
                <hr>
                <h4>Collections</h4>
                <div class="collection-list">

                    <div v-for="c in collections" :key="c._id">{{ c.name }}</div>
                </div>
            </div>
            <div v-if="item._id != null && item._id != ''">
                <hr>
                <h4>Products ({{products.length}})</h4>
                <div class="product-list">
                    <div v-for="p of products" :key="p._id" class="variant">
                        <router-link :to="`/admin/product/variant/${p._id}`" target="_blank">
                            <a class="green-btn" @click="(e) => duplicateThisVariant(e, p._id)"><font-awesome-icon icon="copy" /></a>
                            <img :src="imgURL + '/' + p.mainPicture">
                            <p>{{p.ean}}</p>
                        </router-link>
                    </div>
                </div>
                <hr>
                <h4>Collaborations</h4>
                <div class="product-list">
                    <div v-for="p of collab" :key="p._id" class="variant">
                        <router-link :to="`/admin/product/variant/${p._id}`" target="_blank">
                            <a class="green-btn" @click="(e) => duplicateThisVariant(e, p._id)"><font-awesome-icon icon="copy" /></a>
                            <img :src="imgURL + '/' + p.mainPicture">
                            <p>{{p.ean}}</p>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swal from "sweetalert2";
    import {mapActions} from "vuex";

    export default {
        name: "BrandForm",
        props: {
            name: String,
            item: Object,
            type: String,
            products: Array,
            collab: Array,
        },
        data(){
            return {
                collections: {},
                imgURL: process.env.VUE_APP_S3_URL,
            }
        },
        methods: {
            ...mapActions('product', [
                'uploadImage',
            ]),
            ...mapActions('product', [
                'duplicateVariant',
            ]),
            createItem(){
                if (this.item.name == "") {
                    return Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Item name can\'t be empty!',
                    })
                }
                this.$emit('create', this.item)
            },
            updateItem(){
                if (this.item.name == "") {
                    return Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Item name can\'t be empty!',
                    })
                }
                this.$emit('update', this.item)

            },
            duplicateThisVariant(e, id) {
                e.preventDefault();
                e.stopPropagation();
                this.duplicateVariant(id).then(data => {
                    this.$router.push({ name: 'admin_products_variant', params: { id: data.data.product._id }});
                })
            },
            onFileChange(e) {
                this.files = e.target.files || e.dataTransfer.files;
            },
            uploadPicture() {
                if (!this.files || this.files.length <= 0) return;
                const split = this.files[0].name.split(".");
                let reader = new FileReader();
                reader.readAsDataURL(this.files[0]);
                reader.onload = () => {
                    const image = reader.result.split(',')[1];
                    this.uploadImage({image, ext: split[split.length - 1], name: null, type: '/brands'})
                        .then(res => {
                            if (res.data.success) {
                                this.pending = "";
                                this.item.logo = res.data.file;
                                this.uploadImageError = "";
                            } else {
                                this.pending = res.data.err.message;
                                this.uploadImageError = res.data.msg;
                            }
                        });
                };
            }
        }
    }
</script>

<style scoped lang="scss">
    .header{
        display: flex;
        justify-content: center;
        align-items: center;

        button{
            margin-left: 10px;
        }
    }

    .input-group{
        display: flex;
        justify-content: space-between;
        position: relative;
        border-radius: 3px;
        padding: 0;

        input[type="file"]{
            height: auto;
            padding: 8px 3px 3px 10px;
        }

        .green-btn{
            margin: 0;
        }
    }
    .product-list {
        display: flex;
        flex-wrap: wrap;
        padding: 0;
        margin-bottom: 30px;
        max-height: 300px;
        overflow-y: scroll;

        > .variant {
            height: 120px;
            width: 80px;
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
            margin: 0 10px 10px 0;
            position: relative;

            a {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100%;
                width: 100%;
                text-decoration: none;
            }
            .green-btn {
                max-height: 25px;
                max-width: 25px;
                font-size: 10px;
                position: absolute;
                padding: 0;
                border-radius: 3px;
                top: 2px;
                right: 2px;
            }
            img {
                height: 100%;
            }
            p {
                position: absolute;
                padding: 2px 10px;
                font-size: 13px;
                background-color: var(--main-green);
                color: #B1C4BF;
                transform: skewX(-5deg);
                cursor: pointer;
                margin: 2px;
                font-weight: bold;
                display: none;
            }
            &:hover {
                p {
                    display: inline-block;
                }
            }
        }
    }
    .logo {
        img {
            max-height: 300px;
        }
    }
</style>
